type SquareType = {
  size?: number;
};

const Square = ({ size = 8 }: SquareType) => (
  <div
    style={{
      backgroundColor: "#000",
      border: "1px solid #000",
      height: size,
      width: size,
    }}
  />
);

export default Square;
